export enum CheckoutFlowStep {
  init = 'init', // 0 step
  registration = 'registration', // 1 step
  confirmation = 'confirmation', // 1.5 step
  store = 'store', // last step
  default = init
}
